module.exports = __webpack_public_path__ + "img/upload.259f1ad0.svg";